import { render, staticRenderFns } from "./u-sub-head-basic.vue?vue&type=template&id=3ad0ecfa&scoped=true&"
import script from "./u-sub-head-basic.vue?vue&type=script&lang=js&"
export * from "./u-sub-head-basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad0ecfa",
  null
  
)

export default component.exports